import { StyledButton } from "./styles"
import { Box } from "@mui/material"
import React, { useCallback } from "react"
import { ButtonProps } from "./types"
import { generatePath, useHistory } from "react-router-dom"

const Button: React.FC<ButtonProps> = (props) => {
  const { hidden, text, color, path, isDisabled, type, onClick } = props
  const history = useHistory()

  const handleClick = useCallback(() => {
    if (isDisabled || type !== undefined) {
      return
    } else if (path.includes("http")) {
      const win = window.open(path, "_blank")
      if (win != null) {
        win.focus()
      }
    } else if (path?.length > 0) {
      history.push(generatePath(path))
    }
  }, [history, path, isDisabled, type])

  const buttonColor = () => {
    if (isDisabled) {
      return "info"
    } else {
      return color ? color : "primary"
    }
  }

  return (
    <Box key={"box" + text} sx={{ display: hidden ? "none" : "initial" }}>
      <div
        key={"div" + text}
        style={{ textDecoration: "none" }}
        onClick={onClick ? onClick : handleClick}
      >
        <StyledButton
          type={type}
          fullWidth
          color={buttonColor()}
          variant="contained"
        >
          {text}
        </StyledButton>
      </div>
    </Box>
  )
}

export default Button
